import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam, ISelectProjectParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでプロジェクトコピーが成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosPost(url: string, token?: string) {
  if (token) {
    return axios.post(
      url,
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
  } else {
    return axios.post(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface ICopyProjectParams
  extends ISelectProjectParam,
    ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
}

/**
 * プロジェクトをコピーします
 * @function copyProject
 * @param {ICopyProjectParams} params - プロジェクトコピーパラメータ
 */
export function copyProject(params: ICopyProjectParams): void {
  const { authService, projectid, etag } = params;
  const url = WebAPI.COPY_PROJECT(projectid, etag);
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosPost(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              copyProjectRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosPost(url),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * プロジェクトをコピーします
 * @function copyProjectRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function copyProjectRetry401(
  authService: AuthService,
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosPost(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
